export default __webpack_public_path__ + "static/media/223-turks-and-caicos.65bd29ad.svg";